
import type { PropType } from 'vue'
import type { AsidePanelMessages } from '../../../models'
import { defineComponent } from 'vue'
import EpbAside from '../../aside.component.vue'
import { EpbButton } from '../epb-button'

export default defineComponent({
  name: 'EpbAsideForm',
  components: { EpbAside, EpbButton },
  props: {
    messages: {
      type: Object as PropType<AsidePanelMessages>,
      required: true,
    },
    opened: Boolean,
    clearDisabled: Boolean,
    submitDisabled: Boolean,
    submitVisible: {
      type: Boolean,
      default: true,
    },
  },
  emits: {
    close: () => {},
    clear: () => {},
    submit: () => {},
  },
  setup() {
    return {
      baseClass: 'epb-aside-form',
    }
  },
})
